export const createDistributorFormData = (distributor) => {
  return {
    distributorId: distributor?.distributorId || undefined,
    distributorName: distributor?.distributorName || "",
    srtCode: distributor?.srtCode,
    contact: distributor?.contact,
    landlineNumber: distributor?.landlineNumber,
    address: distributor?.address,
    buildingName: distributor?.buildingName,
    locality: distributor?.locality,
    landmark: distributor?.landmark,
    pincode: distributor?.pincode,
    city: distributor?.city,
    area: distributor?.area,
    region: distributor?.region,
    zone: distributor?.zone,
    country: distributor?.country,
    latLong: distributor?.latLong,
    sendEmail: distributor?.sendEmail,
    email: distributor?.email,
    calculationType: distributor?.calculationType,
    dueDateType: distributor?.dueDateType,
    distributorType: distributor?.distributorType,
    isLocked: distributor?.isLocked,
    distributorGstin: distributor?.distributorGstin,
    creditDays: distributor?.creditDays,
    dlno: distributor?.dlno,
    licValidDate: distributor?.licValidDate,
    cstVat: distributor?.cstVat,
    gstType: distributor?.gstType,
    gstState: distributor?.gstState,
    msmeRegNo: distributor?.msmeRegNo,
    chqName: distributor?.chqName,
    accountNumber: distributor?.accountNumber,
    bankName: distributor?.bankName,
    ifsc: distributor?.ifsc,
    micrCode: distributor?.micrCode,
    openingBalance: distributor?.openingBalance,
    openingTransactionType: distributor?.openingTransactionType,
    creditAmount: distributor?.creditAmount,
    creditPeriod: distributor?.creditPeriod,
    appliedTcs: distributor?.appliedTcs,
    payableFromAdmin: distributor?.payableFromAdmin,
    chqPrintEnable: distributor?.chqPrintEnable,
    panTan: distributor?.panTan,
    distributorSalesPerson: distributor?.distributorSalesPerson,
    distributorSalesMobile: distributor?.distributorSalesMobile,
    visitMonday: distributor?.visitMonday,
    visitTuesday: distributor?.visitTuesday,
    visitWednesday: distributor?.visitWednesday,
    visitThursday: distributor?.visitThursday,
    visitFriday: distributor?.visitFriday,
    visitSaturday: distributor?.visitSaturday,
    visitSunday: distributor?.visitSunday,
    manufacturers: distributor?.manufacturers,
  };
};
